import { createApiSlice } from "@common";
import {
  CRUD_PRODUCT_FEATURES,
  CRUD_PRODUCT_FEATURES_BY_ID
} from "@routes";

const apiConfig = [
  {
    name: "addProductFeatures",
    method: "post",
    url: CRUD_PRODUCT_FEATURES,
    stateKey: "message"
  },
  {
    name: "getProductFeaturesById",
    method: "get",
    url: CRUD_PRODUCT_FEATURES_BY_ID,
    stateKey: "data"
  },
  {
    name: "updateProductFeatures",
    method: "put",
    url: CRUD_PRODUCT_FEATURES,
    stateKey: "message"
  },
  {
    name: "deleteProductFeatures",
    method: "delete",
    url: CRUD_PRODUCT_FEATURES,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
    resetProductFeatures:
      (state) => {
        state.data = [];
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "productFeatures",
  apiConfig,
  customReducers
);
const productFeaturesSlice = slice;

export default productFeaturesSlice.reducer;

export const {
  addProductFeatures,
  getProductFeaturesById,
  updateProductFeatures,
  deleteProductFeatures,

} = thunks;
export const { rowSelect, resetProductFeatures } = actions;
